<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Photousel } from '#library/components.schema.build.ts'
	import Image from '#components/image.svelte'
	import emblaCarouselSvelte from 'embla-carousel-svelte'
	import type { EmblaCarouselType } from 'embla-carousel'
	import Pagination from '#components/pagination.svelte'

	interface Props {
		blok: Blok<Photousel>
	}

	let { blok }: Props = $props()
	let active = $state(0)
	let embla_api: EmblaCarouselType | undefined = $state()

	function onInit(event: CustomEvent) {
		embla_api = event.detail
		if (!embla_api) return

		embla_api.on('select', () => {
			active = embla_api?.selectedScrollSnap() ?? 0
		})
	}
</script>

<section class="photousel breakout {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		{#if blok.items?.length}
			<div use:emblaCarouselSvelte onemblaInit={onInit}>
				<div class="items" use:emblaCarouselSvelte onemblaInit={onInit}>
					{#each blok.items as item, i (i)}
						{#if item?.filename}
							<Image src={item.filename} alt={item.alt} focus={item.focus} />
						{/if}
					{/each}
				</div>
			</div>
		{/if}
	</div>
	<div class="contain">
		<Pagination
			onprev={embla_api?.scrollPrev}
			onnext={embla_api?.scrollNext}
			onpage={embla_api?.scrollTo}
			items={blok.items?.length}
			{active}
			alt
		/>
	</div>
</section>

<style lang="css">
	.photousel {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));

		&.breakout .contain {
			margin-inline: auto;
		}

		:global {
			.pagination {
				grid-column: 1 / -1;
			}
		}
	}

	.items {
		display: flex;
		gap: 2rem;
		margin-block-end: 2.5rem;

		:global(.image) {
			max-height: 30rem;
		}
	}
</style>
